﻿/**
 * portal-quick-link.repository
 * @namespace portal
 */

(function () {
	'use strict';

	/** add the repo */
	angular.module('nha.portal').service('portal-quick-link.repository', portalQuickLinkRepo);

	/** injection */
	portalQuickLinkRepo.$inject = ['repositoryFactory', 'PortalRestangular'];

	/** implementation */
	function portalQuickLinkRepo(repositoryFactory, portalRestangular) {
		/** create the repo */
		var repo = new repositoryFactory('PortalQuickLink', portalRestangular);

		/** additional public methods */
		repo.reorder = reorder;

		/** define custom method */
		function reorder(quicklinks) {
			return this.put(quicklinks, '/reorder');
		}

		/** return the repo */
		return repo;
	}
})();